import { createFileRoute, redirect } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { Role } from '../../types/Role';
import { TokenManager } from '../auth/TokenManager';
import { queries } from '../common/api/queryKeys/queries';
import { CustomerGroupTabs } from '../group/customer/CustomerGroupTabs';
import { CustomerGroupDetailPage } from '../group/customer/detail/CustomerGroupDetailPage';
import { SessionService } from '../user/session/SessionService';

const customerGroupDetailSearchSchema = z.object({
    tab: fallback(
        z.enum([
            CustomerGroupTabs.DETAILS,
            CustomerGroupTabs.SETTINGS,
            CustomerGroupTabs.TWO_STEP_AUTH,
            CustomerGroupTabs.SSO,
            CustomerGroupTabs.DEVELOPERS,
        ]),
        CustomerGroupTabs.DETAILS
    ).default(CustomerGroupTabs.DETAILS),
});

export const Route = createFileRoute('/_app/customer-groups/$groupId/')({
    validateSearch: zodSearchValidator(customerGroupDetailSearchSchema),
    beforeLoad: async ({ context }) => {
        const token = await TokenManager.getInstance().getToken();
        const role = await context.queryClient.ensureQueryData<Role>({
            queryKey: queries.role.information.queryKey,
            queryFn: () => SessionService.getInstance().loadRoleInformation(token),
        });

        if (!role.hasAdminRights()) {
            throw redirect({ to: '/settings' });
        }
    },
    async loader({ params, context }) {
        return Promise.all([
            context.queryClient.ensureQueryData(queries.customerGroups.detail(params.groupId)),
            context.queryClient.ensureQueryData(queries.customers.list({ groupId: params.groupId })),
        ]);
    },
    component: CustomerGroupDetailPage,
});
